export class NotImplementedError extends Error {
  code = 501;

  constructor() {
    super();
  }
}
